import { useState } from 'react';
import { db } from '@/lib/db';
import type { Member } from '@/lib/db/types';
import { Sheet } from '@/components/shared/Sheet';

interface Props {
  member: Member;
  onClose: () => void;
  onSaved: (m: Member) => void;
}

const MAX_CHARS = 500;

export function EditAboutModal({ member, onClose, onSaved }: Props) {
  const [text, setText] = useState(member.about_me || '');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      onSaved(await db.members.update({ about_me: text.slice(0, MAX_CHARS).trim() || null }));
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Sheet title="About Me" onClose={onClose}>
      <div className="p-4">
        <div className="mb-3 text-xs leading-[1.5] text-ink-soft">
          Tell other members about yourself. Keep it friendly and relevant to golf!
        </div>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value.slice(0, MAX_CHARS))}
          placeholder="E.g., Long-time member, love match play, always up for a wager…"
          rows={5}
          className="mb-3.5 w-full resize-y rounded-xl border border-line bg-paper p-3 text-[13px] text-ink outline-none"
        />
        <div className="mb-3.5 text-right text-xs text-mute">{text.length}/{MAX_CHARS} characters</div>
        <div className="flex gap-2.5">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 rounded-[10px] border border-line bg-paper py-3 text-[13px] font-bold text-ink"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => void save()}
            disabled={saving}
            className="flex-1 rounded-[10px] bg-navy py-3 text-[13px] font-bold text-paper disabled:opacity-50"
          >
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </Sheet>
  );
}
